/// <reference path="globals/es6-shim/index.d.ts" />
